import { c as _c } from "react/compiler-runtime";
import { createQueryFn, settingsQueryKeys } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getCouponSettings } from '../../../actions/coupon/entry.js';
const fetcher = createQueryFn(getCouponSettings);
/**
 * Fetch current user coupon settings.
 *
 * @param product Product to fetch settings for.
 * @param settingsKey Settings key, to get settings for either play or my bets/results
 * @param queryOptions Fetch query options
 * @returns Current product coupon settings.
 */
export function useCouponSettings(product, settingsKey, queryOptions) {
  const $ = _c(9);
  let t0;
  if ($[0] !== product || $[1] !== settingsKey) {
    t0 = settingsQueryKeys.product(product, settingsKey);
    $[0] = product;
    $[1] = settingsKey;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[3] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== queryOptions || $[6] !== t0 || $[7] !== t2) {
    t3 = {
      ...queryOptions,
      queryKey: t0,
      queryFn: t2
    };
    $[5] = queryOptions;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useSuspenseQuery(t3);
}